/*
 * BuroEcl
 * Copyright (c) 2023 Buroclic. All rights reserved.
 * 
 * This file corresponds to the ProctedRoute component
 * It is used in App.js in order to check for authentication
 * for pages that needs it before displaying content
 */

import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

export const ProtectedRoute = (props) => {

    // Admin authentication checker
    if (props.admin) {        
        const isAdminAuthenticated = window.localStorage.getItem('isAdminAuthenticated');
        if (!isAdminAuthenticated) {
            return <Navigate to='/admin/login' />
        }


    } else {
        // Common user authentication checker
        const isAuthenticated = window.localStorage.getItem('isAuthenticated');

        // If user not authenticated then
        //  redirects to the login page
        if (!isAuthenticated) {
            const cabinetAlias = window.localStorage.getItem('cabinetAlias');
            
            if (cabinetAlias)
                // redirects to the cabinet signin page if user already signed in once 
                return <Navigate to={{pathname: `/${cabinetAlias}/login`}} />;
            else
                // redirects to the signin error page otherwise
                return <Navigate to='/' />
        }
    }



    // if user authenticated, then
    // let it go through this check
    return props.children;
};

ProtectedRoute.propTypes = {
    admin: PropTypes.bool
}